import { ReactElement } from 'react';

import { DashboardVariantV2CarrierContentContainer } from './styles';
import DashboardVariantV2CarrierContentTabs from './Tabs';

const DashboardVariantV2CarrierContent = (): ReactElement => (
  <DashboardVariantV2CarrierContentContainer>
    <DashboardVariantV2CarrierContentTabs />
  </DashboardVariantV2CarrierContentContainer>
);

export default DashboardVariantV2CarrierContent;
